import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noneName: {
    defaultMessage: 'Coming soon',

    description:
      'The label to display in lieue of the club name when the club is not known yet',
  },
});
